import { denormalize } from 'normalizr';
import { ENTITIES } from './state';
import { ORDER, orderSchema } from './schema';
import { CUSTOMER, BUSINESS, INTERNAL } from './../common/order-types';

export default {
  ORDER_PARAMS: store => {
    return store.ordersParams;
  },

  GET_ORDERS: state => {
    return denormalize(state[ORDER], [orderSchema], state[ENTITIES]);
  },

  GET_ORDERS_C: state => {
    return denormalize(state[ORDER], [orderSchema], state[ENTITIES]).filter(
      order => order.type_id === CUSTOMER
    );
  },

  GET_ORDERS_B: state => {
    return denormalize(state[ORDER], [orderSchema], state[ENTITIES]).filter(
      order => order.type_id === BUSINESS
    );
  },

  GET_ORDERS_P: state => {
    return denormalize(state[ORDER], [orderSchema], state[ENTITIES]).filter(
      order => order.type_id === INTERNAL
    );
  },

  GET_ORDER_BY_ID: state => orderId => {
    return denormalize(Number(orderId), orderSchema, state[ENTITIES]);
  }
};
